import types from 'pages/ReceiveSlip/actions/type.js';
import { defaultPaging } from 'utils/helpers';

const INITIAL_STATE = {
  receiveSlipList: defaultPaging,
  receiveSlipData: undefined,
  getListLoading: false,
  getDetailLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  ordersList: undefined,
  getOrdersLoading: false,
  receiveSlipCode: undefined,
  getCodeLoading: false,
  detailOrder: undefined,
  getOrderLoading: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.GET_LIST_RECEIVESLIP_REQUEST:
      return {
        ...state,
        getListLoading: true,
      };
    case types.GET_LIST_RECEIVESLIP_SUCCESS: {
      return {
        ...state,
        receiveSlipList: action.payload,
        getListLoading: false,
      };
    }
    case types.GET_LIST_RECEIVESLIP_FAILURE:
      return {
        ...state,
        getListLoading: false,
      };
    case types.GET_DETAIL_RECEIVESLIP_REQUEST:
      return {
        ...state,
        getDetailLoading: true,
      };
    case types.GET_DETAIL_RECEIVESLIP_SUCCESS: {
      return {
        ...state,
        receiveSlipData: action.payload,
        getDetailLoading: false,
      };
    }
    case types.GET_DETAIL_RECEIVESLIP_FAILURE:
      return {
        ...state,
        getDetailLoading: false,
      };
    case types.CREATE_REQUEST:
      return {
        ...state,
        createLoading: true,
      };
    case types.CREATE_SUCCESS:
    case types.CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
      };
    case types.UPDATE_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case types.UPDATE_SUCCESS:
    case types.UPDATE_FAILURE:
      return {
        ...state,
        updateLoading: false,
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };
    case types.DELETE_SUCCESS:
    case types.DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
      };
    //get order list
    case types.GET_LIST_ORDER_REQUEST:
      return {
        ...state,
        getOrdersLoading: true,
      };
    case types.GET_LIST_ORDER_SUCCESS: {
      return {
        ...state,
        ordersList: action.payload,
        getOrdersLoading: false,
      };
    }
    case types.GET_LIST_ORDER_FAILURE:
      return {
        ...state,
        getOrdersLoading: false,
      };

    //get code
    case types.GET_CODE_RECEIVESLIP_REQUEST:
      return {
        ...state,
        getCodeLoading: true,
      };
    case types.GET_CODE_RECEIVESLIP_SUCCESS: {
      return {
        ...state,
        receiveSlipCode: action.payload,
        getCodeLoading: false,
      };
    }
    case types.GET_CODE_RECEIVESLIP_FAILURE:
      return {
        ...state,
        getCodeLoading: false,
      };

    //get detail order
    case types.GET_ORDER_REQUEST:
      return {
        ...state,
        getOrderLoading: true,
      };
    case types.GET_ORDER_SUCCESS: {
      return {
        ...state,
        detailOrder: action.payload,
        getOrderLoading: false,
      };
    }
    case types.GET_ORDER_FAILURE:
      return {
        ...state,
        getOrderLoading: false,
      };

    default:
      return state;
  }
}
